import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from '../ui/dropdown-menu'

import { Button } from '../ui/button'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from '@/redux/store'
import { Link, useNavigate } from 'react-router-dom'
import { updateProfileData, userLogout } from '@/redux/asyncThunks/user'

import OGEAvatar from '../OGE/OGEAvatar'
import { SERVER_URL } from '@/api/config'
import ROUTES from '@/routes/routes'

const UserProfile: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>()
  const navigate = useNavigate()
  const user = useSelector((state: RootState) => state.user.user)
  const isLoading = useSelector((state: RootState) => state.user.loading)

  const handleLogout = async () => {
    try {
      await dispatch(userLogout()).unwrap()
      navigate(ROUTES.LOGIN)
    } catch (error) {
      console.error('Logout failed:', error)
    }
  }

  const handleImageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedFile = event.target.files ? event.target.files[0] : null
    if (selectedFile) {
      const formData = new FormData()
      formData.append('profile_picture', selectedFile)
      dispatch(updateProfileData(formData))
    }
  }

  return (
    <div>
      <DropdownMenu>
        <DropdownMenuTrigger>
          <OGEAvatar
            src={
              !user?.profile_picture
                ? undefined
                : user.profile_picture.startsWith('http')
                  ? user.profile_picture
                  : SERVER_URL + user.profile_picture
            }
            fallback={
              user?.name?.substring(0, 2).toUpperCase() ||
              user?.email?.substring(0, 2).toUpperCase()
            }
            variant='md'
            isLoading={isLoading}
          />
        </DropdownMenuTrigger>
        <DropdownMenuContent className='flex flex-col gap-1 py-2 items-center justify-center w-[18.8rem] relative -left-[5.8rem] bg-[#D5DEEBD9] border border-[#E6ECF2 backdrop-blur-[10px]'>
          <div className='relative'>
            <OGEAvatar
              src={
                !user?.profile_picture
                  ? undefined
                  : user.profile_picture.startsWith('http')
                    ? user.profile_picture
                    : SERVER_URL + user.profile_picture
              }
              fallback={
                user?.name?.substring(0, 2).toUpperCase() ||
                user?.email?.substring(0, 2).toUpperCase()
              }
              variant='lg'
              isLoading={isLoading}
            />
            <label
              htmlFor='file-input'
              className='absolute bottom-0 right-0 p-1 bg-white rounded-full shadow-md cursor-pointer'
            >
              <img src='/icons/pencil.svg' alt='Edit' className='h-2.5 w-2.5' />
            </label>

            <input
              id='file-input'
              type='file'
              className='hidden'
              accept='image/*'
              onChange={handleImageChange}
            />
          </div>

          <span className='text-sm font-normal bg-gray-100 px-2 py-0.5 rounded-full'>
            {user?.role ?? ''}
          </span>
          <span className='text-sm font-normal'>Hi, {user?.name ?? ''}!</span>
          <p className='text-sm font-normal'>{user?.email ?? ''}</p>
          <div>
            <Link className='text-base text-[#023572]' to='/profile'>
              Edit Profile
            </Link>
          </div>
          <Button className='h-[2.4rem] w-[7.3rem] bg-dark-blue hover:bg-dark-blue-hovered'>
            <div className='flex items-center gap-2'>
              <img src='/icons/exit.svg' alt='Exit' className='h-3.5 w-3.5' />
              <span onClick={handleLogout} className='text-base font-normal'>
                Sign out
              </span>
            </div>
          </Button>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  )
}

export default UserProfile
